import React from 'react'
import { Link } from 'react-router-dom'
import { BannerPromotional } from '../assets/ExportImageIcon'
import Seo from '../components/Seo'

const ABOUT_JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://sabraah.com/#organization",
      "name": "SabRaah",
      "url": "https://sabraah.com/",
      "description": "SabRaah is an AI-powered travel platform that simplifies trip planning, bookings, and experiences with personalized solutions for travelers worldwide.",
      "sameAs": [
        "https://www.instagram.com/_sabraah_/",
        "https://x.com/_sabraah_",
        "https://www.facebook.com/people/Sabraah/61591311878312/",
        "https://www.linkedin.com/company/sabraah/",
        "https://www.youtube.com/@sabraah_official"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://sabraah.com/#website",
      "url": "https://sabraah.com/",
      "name": "SabRaah",
      "publisher": {
        "@id": "https://sabraah.com/#organization"
      }
    },
    {
      "@type": "AboutPage",
      "@id": "https://sabraah.com/about-us#webpage",
      "url": "https://sabraah.com/about-us",
      "name": "About SabRaah",
      "description": "SabRaah is an AI-powered travel platform that simplifies trip planning, bookings, and experiences with personalized solutions for travelers worldwide.",
      "isPartOf": {
        "@id": "https://sabraah.com/#website"
      },
      "about": {
        "@id": "https://sabraah.com/#organization"
      }
    }
  ]
}

const AboutUs = () => {
  return (
    <>
      <Seo
        title="SabRaah About Us | AI-Powered Travel Platform"
        description="SabRaah is an AI-powered travel platform that simplifies trip planning, bookings, and experiences with personalized solutions for travelers worldwide."
        path="/about-us"
        jsonLd={ABOUT_JSON_LD}
      />

      <section className='commonBanner commonGredientBg'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h1>About Us</h1>
            </div>
          </div>
        </div>
      </section>

      <section className='aboutUs paddingCmn'>
        <div className='container'>
          <div className='row g-4'>

            <div className='col-lg-6 col-md-12'>
              <div className='aboutImg'>
                <img src={BannerPromotional} alt='SabRaah Travel' />
              </div>
            </div>

            <div className='col-lg-6 col-md-12'>
              <div className='aboutContent'>
                <p>
                  SabRaah is a part of Techburg Industries Private Limited. We believe that travel is not just about reaching a destination—it’s about discovering new experiences, creating meaningful memories, and finding your own way through the world.
                </p>
                <p>
                  SabRaah is a smart and innovative travel platform built to simplify the way people
                  discover, plan, and book their journeys. From flights and hotels to holiday
                  packages, unique experiences, and events, we bring essential travel services
                  together in one seamless platform.
                </p>
                <p>
                  Powered by technology and designed around the needs of modern travellers, SabRaah
                  helps you discover options that match your preferences, budget, and travel plans.
                  Whether you're planning a weekend escape, a family holiday, a business trip, an
                  adventure, or looking for memorable events and experiences, our platform makes the
                  entire journey easier and more convenient.
                </p>
                <p>
                  Our goal is to remove the complexity from travel planning and give travellers the
                  freedom to explore with confidence. We continuously combine technology,
                  convenience, and personalized experiences to make every step of your journey
                  smoother.
                </p>
                <p>
                  At SabRaah, we're building more than a travel platform—we're creating a gateway
                  to explore, experience, and connect with the world.
                </p>
                <p className='aboutTagline'>
                  <strong>Your journey starts here. Your way, your experience, your SabRaah.</strong>
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <footer>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='footerLinks'>
                <Link to="mailto:subscribe@sabraah.com">
                  contact us - subscribe@sabraah.com
                </Link>
                <div className='privacyLink'>
                  <Link to="/">Home</Link>
                  |
                  <Link to="/about-us">About Us</Link>
                  |
                  <Link to="/privacy-policy">Privacy Policy</Link>
                  |
                  <Link to="/terms-conditions">Terms & Conditions</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default AboutUs
